import { HTMLCustomElement } from '~/html-custom-element';

export class QuantitySelector extends HTMLCustomElement {
  get input() {
    return this.querySelector('input');
  }

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('click', this.targets.decrease, () => {
      if (!(this.input.min === this.input.value)) {
        this.setInputValue(Number(this.input.value) - 1);
      }
    });

    this.on('click', this.targets.increase, () => {
      if (!(this.input.max === this.input.value)) {
        this.setInputValue(Number(this.input.value) + 1);
      }
    });

    this.on('change', this.input, this.setDisabledStates.bind(this), null, true);
  }

  /**
   * Sets the disabled states of the buttons.
   */
  setDisabledStates() {
    this.targets.increase.disabled = this.input.value === this.input.max;
    this.targets.decrease.disabled = this.input.value === this.input.min;
  }

  /**
   * Sets the input value.
   * @param {Number} value - The input value to set.
   */
  setInputValue(value) {
    this.input.value = value;

    /**
     * Emit the change event.
     */
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
